export default {
  canWrite(context) {
    const field = context.masterDataAccessRights[context.field];
    return field && field.write;
  },
  canRead(context) {
    const field = context.masterDataAccessRights[context.field];
    return field && field.read;
  },
  canDelete(context) {
    const field = context.masterDataAccessRights[context.field];
    return field && field.delete;
  }
};
